import { CheckmarkOutline18Icon } from "@vygruppen/spor-icon-react";
import { FC, ReactNode } from "react";
import { Button } from "shared/components/Spor";
import { useTheme } from "styled-components";

type CheckmarkDropsButtonProps = {
  checked: boolean;
  onClick: () => void;
  children: ReactNode;
};

export const CheckmarkDropsButton: FC<CheckmarkDropsButtonProps> = ({
  checked,
  onClick,
  children,
}) => {
  const theme = useTheme();

  return (
    <Button
      variant="ghost"
      size="xs"
      backgroundColor={checked ? theme.surfaceSelected : "transparent"}
      _hover={{
        backgroundColor: theme.colorOutlineMain,
      }}
      onClick={onClick}
      rightIcon={checked ? <CheckmarkOutline18Icon /> : undefined}
    >
      {children}
    </Button>
  );
};
